// Svenskt momsregistreringsnummer: "SE" + 12 siffror (orgnr utan bindestreck + "01"),
// t.ex. SE556677889901.
export const VAT_SE_REGEX = /^SE\d{12}$/;

export const VAT_SE_ERROR =
  'Ange ett giltigt momsregistreringsnummer, t.ex. SE556677889901.';

export const VAT_ORG_MISMATCH_WARNING =
  'Momsregistreringsnumret matchar inte organisationsnumret. Kontrollera uppgiften.';

/** Ta bort mellanslag och versalisera. */
export const normalizeVat = (raw: string | null | undefined): string =>
  (raw || '').replace(/\s/g, '').toUpperCase();

export const isValidVatSE = (raw: string | null | undefined): boolean =>
  VAT_SE_REGEX.test(normalizeVat(raw));

/** Härled förväntat moms-nr från svenskt orgnr: SE + 10 siffror + 01. Tom sträng om orgnr ofullständigt. */
export const vatFromOrgNumber = (orgNumber: string | null | undefined): string => {
  const digits = (orgNumber || '').replace(/\D/g, '');
  return digits.length === 10 ? `SE${digits}01` : '';
};

/**
 * True om moms-nr stämmer med orgnr (SE + orgnr + 01). Returnerar true när orgnr
 * ännu är ofullständigt eller momsfältet tomt — varning ska inte visas då.
 */
export const vatMatchesOrg = (
  vat: string | null | undefined,
  orgNumber: string | null | undefined
): boolean => {
  const expected = vatFromOrgNumber(orgNumber);
  const value = normalizeVat(vat);
  if (!expected || !value) return true;
  return value === expected;
};
